import React, { Fragment } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "./App.css";
import BookingCom from "./components/bookingCom/bookingCom";
import CardForm from "./components/cardForm/cardForm";
import {
  ARCA_MIMO_BIKE,
  ARCA_MIR,
  ARCA_TOUCH,
  ARCA_TRANSFER,
  MASTER_CARD_GOLD,
  MASTER_CARD_STANDARD,
  TRAVEL_CARD,
  UPI_GOLD,
  UPI_PLATINUM,
  VISA_CLASSIC,
  VISA_GOLD,
  VISA_INFINITE,
  VISA_VISION_BLACK_STANDARD,
  VISA_VISION_WHITE_STANDARD,
} from "./utils/constants";

function App() {
  return (
    <Fragment>
      <Router>
        <Switch>
          {/*<Route path="/hy">*/}
          {/*  <CardForm lang="hy"/>*/}
          {/*</Route>*/}
          {/*<Route path="/en">*/}
          {/*  <CardForm lang="en"/>*/}
          {/*</Route>*/}
          {/*<Route path="/ru">*/}
          {/*  <CardForm lang="ru"/>*/}
          {/*</Route>*/}
          {/*arca-mir*/}
          <Route path="/arca-mir/hy">
            <CardForm lang="hy" card={ARCA_MIR} />
          </Route>
          <Route path="/arca-mir/en">
            <CardForm lang="en" card={ARCA_MIR} />
          </Route>
          <Route path="/arca-mir/ru">
            <CardForm lang="ru" card={ARCA_MIR} />
          </Route>
          {/*arca-mir*/}
          {/*arca-touch*/}
          <Route path="/arca-touch/hy">
            <CardForm lang="hy" card={ARCA_TOUCH} />
          </Route>
          <Route path="/arca-touch/en">
            <CardForm lang="en" card={ARCA_TOUCH} />
          </Route>
          <Route path="/arca-touch/ru">
            <CardForm lang="ru" card={ARCA_TOUCH} />
          </Route>
          {/*arca-touch*/}
          {/*arca-transfer*/}
          <Route path="/arca-transfer/hy">
            <CardForm lang="hy" card={ARCA_TRANSFER} />
          </Route>
          <Route path="/arca-transfer/en">
            <CardForm lang="en" card={ARCA_TRANSFER} />
          </Route>
          <Route path="/arca-transfer/ru">
            <CardForm lang="ru" card={ARCA_TRANSFER} />
          </Route>
          {/*arca-transfer*/}
          {/*arca-mimo-bike*/}
          <Route path="/arca-mimo-bike/hy">
            <CardForm lang="hy" card={ARCA_MIMO_BIKE} />
          </Route>
          <Route path="/arca-mimo-bike/en">
            <CardForm lang="en" card={ARCA_MIMO_BIKE} />
          </Route>
          <Route path="/arca-mimo-bike/ru">
            <CardForm lang="ru" card={ARCA_MIMO_BIKE} />
          </Route>
          {/*aarca-mimo-bike*/}
          {/*master-card-standard*/}
          <Route path="/master-card-standard/hy">
            <CardForm lang="hy" card={MASTER_CARD_STANDARD} />
          </Route>
          <Route path="/master-card-standard/en">
            <CardForm lang="en" card={MASTER_CARD_STANDARD} />
          </Route>
          <Route path="/master-card-standard/ru">
            <CardForm lang="ru" card={MASTER_CARD_STANDARD} />
          </Route>
          {/*master-card-standard*/}
          {/*master-card-gold*/}
          <Route path="/master-card-gold/hy">
            <CardForm lang="hy" card={MASTER_CARD_GOLD} />
          </Route>
          <Route path="/master-card-gold/en">
            <CardForm lang="en" card={MASTER_CARD_GOLD} />
          </Route>
          <Route path="/master-card-gold/ru">
            <CardForm lang="ru" card={MASTER_CARD_GOLD} />
          </Route>
          {/*master-card-gold*/}
          {/*visa-classic*/}
          <Route path="/visa-classic/hy">
            <CardForm lang="hy" card={VISA_CLASSIC} />
          </Route>
          <Route path="/visa-classic/en">
            <CardForm lang="en" card={VISA_CLASSIC} />
          </Route>
          <Route path="/visa-classic/ru">
            <CardForm lang="ru" card={VISA_CLASSIC} />
          </Route>
          {/*visa-classic*/}
          {/*visa-gold*/}
          <Route path="/visa-gold/hy">
            <CardForm lang="hy" card={VISA_GOLD} />
          </Route>
          <Route path="/visa-gold/en">
            <CardForm lang="en" card={VISA_GOLD} />
          </Route>
          <Route path="/visa-gold/ru">
            <CardForm lang="ru" card={VISA_GOLD} />
          </Route>
          {/*visa-gold*/}
          {/*visa-classic*/}
          <Route path="/visa-infinite/hy">
            <CardForm lang="hy" card={VISA_INFINITE} />
          </Route>
          <Route path="/visa-infinite/en">
            <CardForm lang="en" card={VISA_INFINITE} />
          </Route>
          <Route path="/visa-infinite/ru">
            <CardForm lang="ru" card={VISA_INFINITE} />
          </Route>
          {/*visa-classic*/}
          {/*visa-VISION*/}
          <Route path="/visa-vision-black/hy">
            <CardForm lang="hy" card={VISA_VISION_BLACK_STANDARD} />
          </Route>
          <Route path="/visa-vision-black/en">
            <CardForm lang="en" card={VISA_VISION_BLACK_STANDARD} />
          </Route>
          <Route path="/visa-vision-black/ru">
            <CardForm lang="ru" card={VISA_VISION_BLACK_STANDARD} />
          </Route>
          {/*visa-VISION*/}
          {/*visa-VISION*/}
          <Route path="/visa-vision-white/hy">
            <CardForm lang="hy" card={VISA_VISION_WHITE_STANDARD} />
          </Route>
          <Route path="/visa-vision-white/en">
            <CardForm lang="en" card={VISA_VISION_WHITE_STANDARD} />
          </Route>
          <Route path="/visa-vision-white/ru">
            <CardForm lang="ru" card={VISA_VISION_WHITE_STANDARD} />
          </Route>
          {/*visa-VISION*/}

          {/*UPI*/}

          <Route path="/upi-gold/hy">
            <CardForm lang="hy" card={UPI_GOLD} />
          </Route>
          <Route path="/upi-gold/en">
            <CardForm lang="en" card={UPI_GOLD} />
          </Route>
          <Route path="/upi-gold/ru">
            <CardForm lang="ru" card={UPI_GOLD} />
          </Route>

          <Route path="/upi-platinum/hy">
            <CardForm lang="hy" card={UPI_PLATINUM} />
          </Route>
          <Route path="/upi-platinum/en">
            <CardForm lang="en" card={UPI_PLATINUM} />
          </Route>
          <Route path="/upi-platinum/ru">
            <CardForm lang="ru" card={UPI_PLATINUM} />
          </Route>

          {/*UPI*/}

          <Route path="/travel-card/hy">
            <CardForm lang="hy" card={TRAVEL_CARD} />
          </Route>
          <Route path="/travel-card/en">
            <CardForm lang="en" card={TRAVEL_CARD} />
          </Route>
          <Route path="/travel-card/ru">
            <CardForm lang="ru" card={TRAVEL_CARD} />
          </Route>

          {/*visa-classic*/}
          <Route path="/booking/hy">
            <BookingCom lang="hy" />
            {/*<CardForm lang="hy" card={VISA_INFINITE}/>*/}
          </Route>
          <Route path="/booking/en">
            <BookingCom lang="en" />
          </Route>
          <Route path="/booking/ru">
            <BookingCom lang="ru" />
          </Route>
          {/*visa-classic*/}
        </Switch>
      </Router>
    </Fragment>
  );
}

export default App;
